export const yellow = '#fbf3b4';
export const darkBlue = '#040c4b';
